import React from 'react';

import { useMarketFillsQuery } from '#/api/queries/fillQueries';
import { useSelector } from '#/reduxState/store';

import MyTradesTable from './MyTradesTable';
import { useTradesTableRows } from './useTradesTableRows';

type Props = {
  marketFilter: string | undefined;
  onSelectOrder: (orderId: string, highlightFillId: string) => void;
};

export default function MyTradeHistory({ marketFilter, onSelectOrder }: Props) {
  const { data: fills, isFetching } = useMarketFillsQuery(
    marketFilter ?? false
  );

  // Persisted user preference shared with the Trade History page
  const aggregateByOrder = useSelector(
    state => state.exchange.userGuide.tradeHistoryAggregateFills
  );
  const { trades, onToggleAggregation } = useTradesTableRows(
    fills,
    aggregateByOrder
  );

  return (
    <MyTradesTable
      loading={isFetching}
      onSelectOrder={onSelectOrder}
      trades={trades}
      appearAnimationEnabled
      onToggleAggregation={onToggleAggregation}
    />
  );
}
